import { Component, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { rotate, height, opacity } from '../../../animations/animations';

@Component({
    selector: 'accordion-panel',
    templateUrl: './accordion-panel.component.html',
    styleUrls: ['./accordion-panel.component.scss'],
    animations: [rotate('100ms ease-in-out', '180deg'), height('200ms ease-in-out'), opacity('100ms')],
    standalone: false
}) 
export class AccordionPanelComponent implements OnDestroy {
    @Input() opened: boolean = false;
    animationInProgress: boolean = false;
    public onClose$: Subject<void> = new Subject();
    public onOpen$: Subject<void> = new Subject();

    get closeChange() {
        return this.onClose$.asObservable();
    }

    get openChange() {
        return this.onOpen$.asObservable();
    }

    constructor(
        public _changeDetector: ChangeDetectorRef
    ) { }

    ngOnDestroy() {
        this.onClose$.complete();
        this.onOpen$.complete();
    }

    openPanel(): void {
        if (this.opened)
            return;

        this.opened = true;
        this._changeDetector.detectChanges();
        this.onOpen$.next();
    }

    closePanel(): void {
        if (!this.opened)
            return;

        this.opened = false;
        this._changeDetector.detectChanges();
        this.onClose$.next();
    }
}
